<div class="flex flex-1 flex-col gap-2">
  <dx-form
    [formData]="formData"
    [labelLocation]="'top'"
    [showColonAfterLabel]="false"
    (onFieldDataChanged)="onFieldDataChanged()"
    [colCount]="1"
    [readOnly]="readonly"
  >
    <dxi-item
      dataField="title"
      [label]="{ visible: false }"
      [editorOptions]="{ placeholder: 'Titolo' | transloco }"
    ></dxi-item>
    <dxi-item
      dataField="options"
      [label]="{ visible: false }"
      [editorOptions]="{
        placeholder: ('Opzioni (separate da virgola)' | transloco)
      }"
    ></dxi-item>
  </dx-form>
</div>
